import * as React from 'react';
import { st, classes } from './ShareButton.st.css';
import { TextButton } from '../TextButton';
import { TextButtonPriority } from '../TextButton/types';
import { Share } from '@wix/wix-ui-icons-common/on-stage';
/** Opens navigator.share where available */
export class ShareButton extends React.Component {
    constructor() {
        super(...arguments);
        this.onButtonClick = () => {
            let sharePromise;
            const { shareData } = this.props;
            if (navigator.share) {
                sharePromise = navigator.share(shareData);
            }
            this.props.onClick(sharePromise);
        };
    }
    render() {
        const { shareData, text, withIcon, className, disabled, ...rest } = this.props;
        return (React.createElement(TextButton, { className: st(classes.root, { withIcon }, className), priority: TextButtonPriority.secondary, prefixIcon: withIcon ? (React.createElement(Share, { className: st(classes.icon, { disabled }) })) : undefined, disabled: disabled, ...rest, onClick: this.onButtonClick, "data-hook": this.props['data-hook'] },
            React.createElement("div", { className: classes.text }, text)));
    }
}
ShareButton.displayName = 'ShareButton';
//# sourceMappingURL=ShareButton.js.map